export const environment = {
  production: true,
  apiUrl: 'https://api.mybase.pro/',
  // Куда ведёт перенос базы знаний.
  lovoxUrl: 'https://lovox.ru'
};
